var Radio_module_default = {
	container: "_container_1ug7n_10",
	input: "_input_1ug7n_18",
	ui: "_ui_1ug7n_19"
};
//#endregion
export { Radio_module_default as default };

//# sourceMappingURL=Radio.module.js.map